import PropTypes from 'prop-types';
import React from 'react';
import { CSVLink} from "react-csv";
import cx from 'classnames';
import { Image, Row, Col, Card, FormGroup, InputGroup, FormControl, Button as SearchButton } from 'react-bootstrap';
import Transition from 'react-transition-group/Transition';
import buildUrl from 'build-url-ts';
import { ToolBar, ToolBarGroup, ToolBarTabItem } from 'src/legacy/components/ToolBar/ToolBar.jsx';
import { ToolBarButtonItem } from 'src/legacy/components/ToolBar/ToolBarButtonItem.jsx';
import SlidePaneView from 'src/legacy/components/SlidePaneView';
import PlaceholderEmptyMessage from 'src/legacy/components/PlaceholderEmptyMessage';
import RolodexActivityEmptyMessage from 'src/legacy/images/rolodexActivityEmptyMessage.svg';
import styles from './userGroupDetailView.module.scss';
import dateformat from 'dateformat';
import BackButton from 'src/legacy/components/BackButton';
import isEqual from 'is-equal';
import UserGroupListContainer from './UserGroupListContainer';
import UserListItemRow from './components/UserListItemRow';
import AddUsersContainer from './AddUsers/AddUsersContainer';
import { toast } from 'react-toastify';
import DeleteUserGroupView from './delete/DeleteUserGroupContainer';
import _ from 'lodash'
import { localizedStrings } from 'src/localization/index.jsx';
import userRoleService from 'src/utils/userRoles.service';
import Button from 'src/components/button';
import Toast from 'src/components/toast';

class UserGroupDetailView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired
  }
  constructor(props) {
    super(props);

    this.state = {
      query: "",
      name: "",
      admin: false,
      createStream: false,
      errors: {},
      creating: false,
      addUsersView: false,
      deleting: false,
      downloadData: [],
      

    }




    this._handleSearch = this._handleSearch.bind(this);
    this.loadUserGroup = this.loadUserGroup.bind(this);
    this._handleChange = this._handleChange.bind(this);
    this._handleCreateGroupClick = this._handleCreateGroupClick.bind(this);
    this._handleAccessChange = this._handleAccessChange.bind(this);

    this._handleSaveClick = this._handleSaveClick.bind(this);
    this._handleCancelCreate = this._handleCancelCreate.bind(this);
    this._handleUpdateClick = this._handleUpdateClick.bind(this);
    this._handleCancelUpdate = this._handleCancelUpdate.bind(this);

    this._handleAddUsersClick = this._handleAddUsersClick.bind(this);
    this._handleCancelAddUser = this._handleCancelAddUser.bind(this);
    this._handleFinishAddUser = this._handleFinishAddUser.bind(this);
    this._handleRemoveUser = this._handleRemoveUser.bind(this);
    this._handleDeleteClicked = this._handleDeleteClicked.bind(this);

    this._handleSearchQueryChange = this._handleSearchQueryChange.bind(this);


    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonLoading = this.localizedCommons.loading;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedUserManagement = this.localizedSettings.account.user_management;
    this.localizedNewGroup = this.localizedUserManagement.create_new_group;
  }

  _handleSearch(event) {
    event.preventDefault();

    var queryParams = {};
    if (this.state.query) {
      queryParams['query'] = this.state.query;
    }

    var path = buildUrl(null, {
      path: this.props.location.pathname,
      queryParams: queryParams
    });

    this.props.navigate(path);
  }

  _handleChange(field, e) {
    this.setState({
      [field]: e.target.value,
      errors: {}
    });
  }

  _handleSearchQueryChange(e) {
    this.setState({
      query: e.target.value
    })
  }

  _handleAccessChange(field, e) {

    let createStream = this.state.createStream;
    if (field == "admin" && !this.state.admin && !createStream) {
      createStream = true
    } else if (field == "createStream") {
      createStream = !this.state.createStream;
    }
    this.setState({
      [field]: !this.state[field],
      createStream: createStream
    });
  }

  componentDidMount() {
    this.props.hideSettingsSideMenu();
      
    if (!this.props.userGroups || this.props.userGroups.length == 0) {
     
      this.props.fetchUserGroups(0, _.get(this.props,"location.query.query")).then(() => {
        if (this.props.params.id != "new") {
          this.loadUserGroup(this.props.params.id);
        }
      });
    } else {
      if (this.props.params.id != "new") {
        this.loadUserGroup(this.props.params.id);
      }
    }

    if (this.props.params.id == "new") {
      this._handleCreateGroupClick();
    }

    var query = this.props.location.query['query'] || '';
    if (query) {
      this.setState({
        query: query
      })
    }



    if (this.props.userGroup) {

      const downloadData = _.map(_.get(this.props,"userGroup.users",[]), obj => _.pick(obj, ['firstName','lastName','email','userRoleName']))
      this.setState({
        name: this.props.userGroup.name,
        admin: this.props.userGroup.admin,
        createStream: this.props.userGroup.createStream,
        downloadData
       

      })
      
    }
  }

  componentWillReceiveProps(nextProps) {

    if (!isEqual(this.props.params.id, nextProps.params.id)) {

      if (nextProps.params.id != "new") {
        this.loadUserGroup(nextProps.params.id);
        this.setState({
          creating: false
        })
       
      } else {
      
        this.setState({
          name: this.localizedCommons.untitled,
          admin: false,
          createStream: false
        })
      }

      var query = nextProps.location.query['query'] || '';
      if (query) {
        this.setState({
          query: query
        })
      }
    }

    var oldId = this.props.userGroup ? this.props.userGroup.id : null;
    var newId = nextProps.userGroup ? nextProps.userGroup.id : null;
    if (!isEqual(oldId, newId) && nextProps.userGroup && nextProps.params.id != "new" && !nextProps.updating) {
      const downloadData = _.map(_.get(nextProps,"userGroup.users",[]), obj => _.pick(obj, ['firstName','lastName','email','userRoleName']))
      this.setState({
        name: nextProps.userGroup.name,
        admin: nextProps.userGroup.admin,
        createStream: nextProps.userGroup.createStream,
        downloadData

      })
    }
  }
 
  loadUserGroup(id) {
    this.props.fetchUserGroup(id);
  }

  _handleCreateGroupClick() {
    this.props.navigate("/settings/user-management/group/new");
    this.setState({
      creating: true,
      name: this.localizedCommons.untitled,
      admin: false,
      createStream: false
    })
  }

  _handleCancelCreate() {
    this.setState({
      creating: false,
      errors: {}
    })

    this.props.navigate("/settings/user-management/group");
    this.props.invalidateUserSelection();
  }

  _handleSaveClick() {
    let errors = this._validateForm();

    if (Object.keys(errors).length > 0) {
      this.setState({
        errors: errors
      })

      return;
    }
   
  
   

    var userIds = this.props.selectedUsers.map((user) => {
      return user.id;
    })

    var request = {
      name: this.state.name,
      admin: this.state.admin,
      canCreateStream: this.state.createStream,
      users: userIds
    }

    this.props.createUserGroup(request).then((response) => {
      this.props.invalidateUserSelection();
      this.props.navigate(`/settings/user-management/group/${response.payload.id}`);
      this.setState({
        creating: false
      })
      toast(
        <Toast.Sucess
          message={this.localizedNewGroup.toast.group_created}
        />, {
        autoClose: 3000,
      })
    })
  }

  _handleUpdateClick() {
    let errors = this._validateForm();

    if (Object.keys(errors).length > 0) {
      this.setState({
        errors: errors
      })

      return;
    }

    var userIds = this.props.userGroup.users.map(user => {
      return user.id;
    })

    var request = {
      name: this.state.name,
      admin: this.state.admin,
      canCreateStream: this.state.createStream,
      users: userIds
    }

    this.props.updateUserGroup(this.props.userGroup.id, request).then(() => {
      toast(
        <Toast.Sucess
          message={localizedStrings.formatString(this.localizedNewGroup.toast.update, {name: this.props.userGroup.name})}
        />, {
        autoClose: 3000,
      })
    });
  }

  _handleRemoveUser(user) {
    if (this.props.userGroup) {
      this.props.removeUserFromUserGroup(this.props.userGroup.id, user);
    } else {
      this.props.deselectUser(user);
    }
  }

  _handleCancelUpdate() {
    this.props.fetchUserGroup(this.props.userGroup.id).then(() => {
      this.setState({
        name: this.props.userGroup.name,
        admin: this.props.userGroup.admin,
        createStream: this.props.userGroup.createStream
      })
    });
  }

  _handleAddUsersClick() {
    this.setState({
      addUsersView: true
    })
  }

  _handleCancelAddUser() {
    this.props.invalidateUserSelection();
    this.setState({
      addUsersView: false
    })
  }

  _handleFinishAddUser() {
    this.setState({
      addUsersView: false
    })
  }

  _validateForm() {
    var errors = {};
    if (!this.state.name || this.state.name.trim() == '') {
      errors['name'] = this.localizedNewGroup.error_message;
    }

    return errors;
  }

  _handleDeleteClicked() {
    this.setState({
      deleting: true
    })
  }
 



  render() {
    return (
      <Row className={cx(styles.content)}>
        {this.state.addUsersView && <div className={styles.backgroundContainer} />}
        <div className={cx(styles.listView)}>
          <BackButton
            className={styles.back}
            title="BACK"
            onClick={() => {
              this.props.navigate(`/settings/user-management`);
              this.props.showSettingsSideMenu();
            }}>
          </BackButton>

          <h1 className={styles.heading}>{this.localizedNewGroup.title}</h1>

          <div className={styles.createUserGroup}>
            <div className={cx(styles.button, { [styles.disabled]: this.state.creating, [styles.create]: !this.state.creating })} onClick={this._handleCreateGroupClick}>
              <i className="paperflite-add" aria-hidden="true" /> {this.localizedNewGroup.actions.create_new_group}
            </div>
          </div>

          <form className={styles.search} onSubmit={this._handleSearch}>
            <FormGroup className={styles.formGroup}>
              <div className={styles.searchContainer}>
                <div className={styles.addon}>
                  <span className={cx(styles.icon, "paperflite-search")}></span>
                </div>
                <FormControl type="text"
                  placeholder={this.localizedNewGroup.placeholder}
                  value={this.state.query}
                  onChange={this._handleSearchQueryChange} />
                <div>
                  <SearchButton className={styles.button} type="submit">{this.localizedCommonActions.search}</SearchButton>
                </div>
              </div>
            </FormGroup>
          </form>

          <UserGroupListContainer store={this.context.store}
            query={this.state.query}
            creating={this.state.creating}
            selectedId={this.props.params.id}
            location={this.props.location} />
        </div>
        <div className={cx(styles.column, styles.detailsView)}>
          <Transition
            in={this.state.addUsersView}
            timeout={0}>
            {
              (state) => {
                return (
                  <Col xs={12} sm={12} md={12} lg={12} className={cx(
                    styles.addUserContainer,
                    styles[state]
                  )}>
                    <AddUsersContainer
                      className={styles.userNameDisplay}
                      userGroup={this.props.userGroup}
                      onFinish={this._handleFinishAddUser}
                      onCancel={this._handleCancelAddUser}
                      loadUser={this.state.addUsersView}
                      isAdministrator = {this.state.admin}
                      isCreateStream = {this.state.createStream}
                      name = {this.state.name}
                    />
                  </Col>
                );
              }
            }
          </Transition>
          {this._renderDetailsView()}

          <Transition
            in={true}
            timeout={0}>
            {
              (state) => {
                return (
                  <div className={cx(styles.actions, styles[state])}>
                    <Button
                      onClick={this.state.creating ? this._handleSaveClick : this._handleUpdateClick}
                      text={this._renderButtonText()}
                      disabled={this.props.updating || this.props.creating}
                      variant='primary'
                      icon='paperflite-tick'
                    />
                    <Button
                      onClick={this.state.creating ? this._handleCancelCreate : this._handleCancelUpdate}
                      text={this.localizedCommonActions.cancel}
                      variant='secondary'
                    />
                  </div>
                );
              }
            }
          </Transition>
        </div>
      </Row>
    )
  }



  _renderDetailsView() {
    if (!this.props.userGroup && !this.state.creating) {
      return null;
    }

    const headers = [
      { label: this.localizedNewGroup.headers.first_name, key: "firstName" },
      { label: this.localizedNewGroup.headers.last_name, key: "lastName" },
      { label: this.localizedNewGroup.headers.email, key: "email" },
      {label: this.localizedNewGroup.headers.role, key: "userRoleName"}
      
    ];
    
    return (
      <div className={cx(styles.detailsContainer, { [styles.fade]: this.state.addUsersView })}>
        <div className={styles.inner} ref={(element) => {
          this.scrollContainer = element;
        }}>
          <Row className={styles.userGroupDetails}>
            <Col md={12} className={styles.noPadding}>
              <div>
                <div className={styles.body}>
                  <div className={styles.nameContainer}>
                    <input
                      className={styles.nameInput}
                      type="text"
                      placeholder={this.localizedNewGroup.group_name_placeholder}
                      onChange={this._handleChange.bind(this, 'name')}
                      value={this.state.name}
                      spellCheck={true} />
                    {this.state.errors.name &&
                      <span className={styles.errorMessage}>
                        <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                        {this.state.errors.name}
                      </span>
                    }

                    <ToolBar className={cx(styles.toolbar, { [styles.trial]: this.props.trial })}>
                      <ToolBarGroup direction="right">
                        {_.size(_.get(this.props, "userGroup.users", 0)) > 0 && <ToolBarButtonItem className={cx(styles.download)} width="auto" height="auto" >
                          <CSVLink headers={headers} className={styles.action} data={this.state.downloadData} filename={_.get(this.props, "userGroup.name", "")}>
                            <span className={cx("paperflite-download", styles.addDownload)}></span>{this.localizedCommonActions.download}
                          </CSVLink>
                        </ToolBarButtonItem>}
                        <ToolBarButtonItem className={cx(styles.action)} width="auto" height="auto" onClick={this._handleAddUsersClick}>
                          <span className={cx("paperflite-add", styles.addUsers)}></span>{this.localizedCommonActions.add_users}
                        </ToolBarButtonItem>
                        {!this.state.creating &&
                          <ToolBarButtonItem className={cx(styles.action)} width="auto" height="auto" onClick={this._handleDeleteClicked}>
                            <i className="paperflite-delete" />{this.localizedCommonActions.delete}
                          </ToolBarButtonItem>}
                      </ToolBarGroup>
                    </ToolBar>
                  </div>
                  <div className={styles.permissions}>
                    <label>{this.localizedNewGroup.permission.title} :</label>
                    <div className={styles.access}>
                      <div className={styles.accessLevel}>
                        <i className={cx(this.state.admin ? 'paperflite-tick-selected' : 'paperflite-radio-button-unselected')} onClick={this._handleAccessChange.bind(this, "admin")} aria-hidden="true"></i>
                        <span>{this.localizedNewGroup.permission.administrator}</span>
                      </div>
                      {userRoleService.canAccessHub() &&
                        <div className={cx(styles.accessLevel, { [styles.disabled]: this.state.admin })}>
                          <i className={cx(this.state.createStream ? 'paperflite-tick-selected' : 'paperflite-radio-button-unselected')} onClick={this._handleAccessChange.bind(this, "createStream")} aria-hidden="true"></i>
                          <span>{this.localizedNewGroup.permission.content_publisher}</span>
                        </div>
                      }
                    </div>
                    {!this.state.creating && <div className={styles.listMeta}>
                      <span className={styles.label}>{this.localizedCommons.created_by} :</span>
                      <span className={styles.value}>{`${_.get(this.props, "userGroup.createdBy.firstName")} ${_.get(this.props, "userGroup.createdBy.lastName")}`}</span>
                    </div>}
                  </div>

                </div>
              </div>
            </Col>
        
          </Row>

          {this._renderUsers()}
        </div>

        {this.props.userGroup &&
          <SlidePaneView width="30vw" show={this.state.deleting}>
            <DeleteUserGroupView
              id={this.props.userGroup.id}
              onDeletion={
                () => {
                  this.setState({
                    deleting: false
                  })
                }
              }
              onCancel={
                () => {
                  this.setState({
                    deleting: false
                  })
                }
              }
            />
          </SlidePaneView>}
      </div>
    )
  }

  _renderButtonText() {
    if (this.state.creating) {
      return this.props.creating ? `${this.localizedCommonActions.creating}...` : this.localizedCommonActions.create;
    } else {
      return this.props.updating ? `${this.localizedCommonActions.saving}...` : this.localizedCommonActions.save;
    }
  }

  _renderUsers() {
    if (!this.props.creating && !this.props.loading && this.props.userGroup && this.props.userGroup.users.length == 0) {
      return this._renderEmptyMessage();
    }

    if (!this.props.userGroup && (this.props.selectedUsers == null || this.props.selectedUsers.length == 0)) {
      return this._renderEmptyMessage();
    }

    if (this.props.loading) {
      return (
        <div>{this.localizedCommonLoading.loading}...</div>
      )
    }

    var items = this.props.userGroup && this.props.userGroup.users || [];

    if (this.state.creating) {
      items = [...items, ...this.props.selectedUsers];
      items = items.sort((a, b) => {
        return a.firstName.localeCompare(b.firstName);
      });
    }
    var users = items.map(user => {
      var listStyle = {};

      if (user.id === this.props.user.id) {
        listStyle = styles.disableClick;
      }
      return (
        <UserListItemRow
          key={user.id}
          user={user}
          onRemove={this._handleRemoveUser}
          className={listStyle}
        />
      )
    })

    var usersCount = this.props.userGroup ? this.props.userGroup.users.length : 0;
    if (this.state.creating) {
      usersCount += this.props.selectedUsers.length;
    }

    return (
      <div>
        <Row className={styles.usersHeading}>
          <Col md={6} className={styles.column}>
            <span>{this.localizedCommons.users}</span> <span className={styles.count}>{`(${usersCount})`}</span>
          </Col>
        </Row>
        <div className={styles.usersContainer}>
          {users}
        </div>
      </div>
    )
  }

  _renderEmptyMessage() {
    return (
      <PlaceholderEmptyMessage
        title={this.localizedNewGroup.empty_message}
        message=""
        image={RolodexActivityEmptyMessage}
        className={cx(styles.emptyMessage)}
        buttonText={this.localizedNewGroup.actions.add_users}
        onClick={this._handleAddUsersClick}
        visible={true}
      />
    );
  }
}

export default UserGroupDetailView;    